import { createAction } from '@ngrx/store';

export const enterAction = createAction('[Thermostats Page] Enter');
export const filterAction = createAction(
  '[Thermostats Page] Filter',
  (searchTerm: string) => ({ searchTerm }),
);
